export default "__VITE_ASSET__Cr$sG4Y1__"